import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  HostListener,
  Input,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  AfterViewInit,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MheOption } from "../../shared/components/shared";
import { ButtonType } from "../../shared/components/button/button-type";
import { ButtonPurpose } from "../../shared/components/button/button-purpose";
import { AutoUnsubscribe } from "./../../shared/components/decorator/autoUnsubscribe.decorator";
import { OrderByPipe } from "./../../shared/pipes/order-by.pipe";
import { PaginatePipe } from "./../../shared/pipes/pagination.pipe";
import { GrdFilterPipe } from "./../../shared/pipes/grd-filter.pipe";
import { AssessmentListService } from "../../shared/services/assessment-list.service";
import { ShareDataService } from "../../shared/services/shared.service";
import { KebabMenuInterface } from "./../../shared/models/kebab-menu-model";
import { filter, Subscription, switchMap, take, tap } from "rxjs";
import { Router } from "@angular/router";
import { AlertType } from "../../shared/components/alert/alert-type";
import { getKebabElements, queueLiveAnnouncement } from "src/app/utils/shared-utils";
import { ASSESSMENT_LIST_ANNOUNCEMENT_DURATION_MS, ASSESSMENT_LIST_ANNOUNCEMENT_DELAY_MS } from "../../utils/stringConstants";
import { LiveAnnouncer } from '@angular/cdk/a11y';
@Component({
    selector: "app-assessment-list",
    templateUrl: "./assessment-list.component.html",
    styleUrls: ["./assessment-list.component.scss"],
    standalone: false
})
export class AssessmentListComponent implements OnInit, OnDestroy, AfterViewInit {
  assessmentListdata = [];
  assessmentListdataCopy = [];
  private error;
  Math: any;
  private pageNumber = 0;
  private totalPage: number;
  public totalItems: number = 0;
  private itemsPerPage = 10;
  public collectionLength = 0;
  public searchText: string = "";
  private isSearchDirty: boolean = false;
  public show = false;
  private spinner: boolean = false;
  public isAnyModalOpen: boolean = false;
  private lastRefreshTime: number = 0;
  public qti: string = "qtiPackage";
  public docx: string = "document";
  public message: String = "";
  direction: number;
  isDesc: any;
  column: any;
  alertMessage: string = "";
  public kebabIndex: number;
  public alertType = AlertType;
  public assessmentListSubscription: Subscription;
  public fileDownlodSubscription: Subscription;
  public resyncSubscription: Subscription;
  public testInfoMessageSubscription: Subscription;
  public buttonType = ButtonType;
  public _buttonPurpose = ButtonPurpose;
  private currentSortColumn: string = '';
  private currentSortDirection: 'asc' | 'desc' | 'none' = 'none';
  fileContent: string = "";
  kebabMenu: KebabMenuInterface;
  modalIsVisible: boolean = false;
  showSuccessMessage: boolean = false;
  showErrorMessage: boolean = false;
  showInfoMessage: boolean = false;
  isDisableUpload: boolean = true;
  showExportErrorMessage: boolean = false;
  errorMessage: string =
    "There was a problem importing your test. Please try again.";
  fileData: any = "";
  @ViewChild("myInput") myInputVariable: ElementRef;
  @ViewChild("assessmentListTable") assessmentListTable: ElementRef;
  @ViewChildren('columnHeader') columnHeaders!: QueryList<ElementRef>;
  selectedOption: MheOption[] = [];
  ngModelOptions: MheOption[] = [
    {
      value: 0,
      viewValue: "Create New Test",
      actionType: 'page'
    },
    {
      value: 1,
      viewValue: "Import Test",
      actionType: 'modal'
    },
  ];
  createTestText: string = "Create Test";
  searchResultsAnnouncement: string = "";
  infoMessage: string = "";
  //sortFlag: number = undefined;
  sortAscDsc = {
    collection_title: "dpg-icon-system-sort-white",
    modified: "dpg-icon-system-sort-white",
    isbnTitle: "dpg-icon-system-sort-white",
    isbnAuthor: "dpg-icon-system-sort-white",
    isbnEdition: "dpg-icon-system-sort-white",
    modified_format: "dpg-icon-system-sort-white",
  };
  public showKebabAbove: boolean = false;
  private MENU_HEIGHT: number = 290;
  private Z_INDEX_HIGHLIGHTED_ROW: number = 1000;

  constructor(
    private router: Router,
    private assessmentList: AssessmentListService,
    private shareDataService: ShareDataService,
    private renderer: Renderer2,
    private collectionListPipe: OrderByPipe,
    private paginate: PaginatePipe,
    private searchFilter: GrdFilterPipe,
    private cdr: ChangeDetectorRef,
    private titleService: Title,
    private liveAnnouncer: LiveAnnouncer
  ) {}
  ngOnInit() {
    const pageTitle = "My Tests | Test Builder";
    this.titleService.setTitle(pageTitle);
    /* In SPAs, some screen readers or browser/screen-reader combinations may not reliably announce
    title changes. LiveAnnouncer explicitly announces the page title as an accessibility fallback.
    The delay allows status messages to read first, before announcing the page title. */
    queueLiveAnnouncement(
      this.liveAnnouncer,
      pageTitle,
      "polite",
      ASSESSMENT_LIST_ANNOUNCEMENT_DURATION_MS,
      ASSESSMENT_LIST_ANNOUNCEMENT_DELAY_MS,
    );
    this.assessmentListdata["collections"] = [];
    this.populateTestList();
    this.kebabMenu = {
      addNewPart: false,
      get_info: true,
      preview: false,
      pinUnpin: false,
      edit: true,
      copy: true,
      export: true,
      rename: true,
      print: false,
      delete: true,
      remove: false,
      copyAndEdit: false,
      pastUsage: false,
      editQuestion: false,
    };
  }

  ngOnDestroy() {
    if (this.testInfoMessageSubscription) {
      this.testInfoMessageSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    /* When tabbing through the table, focus can move to columns that are off-screen.
     *This listener scrolls the focused element into view horizontally for better accessibility.
     */
    const tableElement = this.assessmentListTable.nativeElement as HTMLElement;
    tableElement.addEventListener('focus', (event: FocusEvent) => {
      const target = event.target as HTMLElement;

      if (this.isElementOutOfView(target, tableElement)) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }, true);

    this.testInfoMessageSubscription = this.shareDataService.getTestInfoMessageData()
      .pipe(
      filter(data => !!data && (data.mode === 'edit' || data.mode === 'create')),
      switchMap((data) =>
        this.shareDataService.getSpinnerData().pipe(
        filter((spinnerValue: boolean) => spinnerValue === true),
        take(1),
        tap(() => {
          this.showSuccessAlert(data.message);
          this.cdr.detectChanges();
          this.shareDataService.sendTestInfoMessageData(null);
        })
        )
      )
      )
      .subscribe();
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    const { kebabButton, kebabIcon, kebabMenu } = getKebabElements(event.target);

    if (!kebabButton && !kebabIcon && !kebabMenu) {
      this.kebabIndex = -1;
    }
    if (document.getElementsByClassName("ahe-ui-alert-modal").length > 0) {
      this.kebabIndex = -1;
    }
  }
  closeAlert(type?: string) {
    const resetAlerts = () => {
      this.showSuccessMessage = false;
      this.showErrorMessage = false;
      this.showInfoMessage = false;
      this.alertMessage = "";
    };

    if (type === "manual") {
      resetAlerts();
    } else {
      setTimeout(resetAlerts, 8000);
    }
  }

  public get displayKebabAbove(): boolean {
    return this.showKebabAbove;
  }

  public setKebabIndex(index: number, rowElement?: HTMLElement) {
    // If clicking on the same kebab that's already open, close it
    if (this.kebabIndex === index) {
      this.kebabIndex = -1;
      return;
    }

    this.kebabIndex = index;
    const trs = this.assessmentListTable.nativeElement.querySelectorAll("tr");
    trs.forEach((tr) => {
      tr.style.zIndex = "0";
    });
    rowElement.style.zIndex = this.Z_INDEX_HIGHLIGHTED_ROW.toString();
    const currentColumn = rowElement.querySelector('td:last-child') as HTMLElement;
    this.showKebabAbove = this.isTableHeightExceeded(currentColumn);
  }

  public isTableHeightExceeded(currentColumn: HTMLElement): boolean {
    const menuHeight = this.MENU_HEIGHT;
    const tableRect = this.assessmentListTable.nativeElement.getBoundingClientRect();
    const buttonRect = currentColumn.getBoundingClientRect();

    const spaceBelow = tableRect.bottom - buttonRect.bottom;
    const spaceAbove = buttonRect.top - tableRect.top;

    return (spaceBelow < menuHeight && spaceAbove >= menuHeight);
  }

  private isElementOutOfView(element: HTMLElement, container: HTMLElement): boolean {
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const parentEl = container.parentElement;
    const parentRect = parentEl?.getBoundingClientRect();
    const stickyCol = container.querySelector('.sticky-col') as HTMLElement | null;
    const stickyWidth = parentEl && parentEl.scrollWidth > parentEl.clientWidth
      ? stickyCol?.getBoundingClientRect().width ?? 0 : 0;
    const leftBoundary = parentRect?.left ?? containerRect.left;
    const rightBoundary = (parentRect?.right ?? containerRect.right) - stickyWidth;

    const isOutOfViewHorizontally = !element.closest('.sticky-col') &&
      (elementRect.left < leftBoundary || elementRect.right > rightBoundary);

    const isOutOfViewVertically =
      elementRect.bottom < containerRect.top ||
      elementRect.top > Math.min(containerRect.bottom, window.innerHeight);

    return isOutOfViewHorizontally || isOutOfViewVertically;
  }

  showModal() {
    this.modalIsVisible = !this.modalIsVisible;
  }
  closeUploadModal() {
    this.modalIsVisible = false;
    this.modalIsVisible = false;
    this.showErrorMessage = false;
    this.errorMessage =
      "There was a problem importing your test. Please try again.";
    this.myInputVariable.nativeElement.value = "";
    this.fileData = null;
    this.isDisableUpload = true;
    this.selectedOption = [];
  }
  public onChange(fileList: FileList): void {
    let file = fileList[0];
    if (file !== undefined) {
      this.isDisableUpload = false;
      this.fileData = file;
    } else {
      this.isDisableUpload = true;
      this.fileData = "";
    }
    this.showErrorMessage = false;
  }
  public clearFile(inputElement: HTMLInputElement, event: MouseEvent | KeyboardEvent | PointerEvent): void {
    this.fileData = null;
    this.isDisableUpload = true;
    this.showErrorMessage = false;
    inputElement.value = "";
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
    }
    inputElement.focus();
  }
  showSuccessAlert(message: string) {
    this.alertMessage = message;
    this.showSuccessMessage = true;
    this.closeAlert();
  }
  uploadTestData() {
    this.modalIsVisible = true;
    const previousError = this.errorMessage;
    const testFileData: FormData = new FormData();
    testFileData.append("files", this.fileData, this.fileData.name);
    this.assessmentList.uploadTestFile(testFileData).subscribe(
      () => {
        this.closeUploadModal();
        this.showSuccessMessage = true;
        this.showSuccessAlert("Your test has been successfully imported.");
        this.fileData = null;
        this.isDisableUpload = true;
        this.populateTestList();
      },
      (err) => {
        if (
          err.hasOwnProperty("error") &&
          err.error.hasOwnProperty("Message")
        ) {
          this.errorMessage = err.error.Message;
        }
          if (previousError === this.errorMessage && this.showErrorMessage) {
            this.forceErrorReannouncement();
          } else {
            this.showErrorMessage = true;
          }
      }
    );
  }

  private forceErrorReannouncement(): void {
    this.showErrorMessage = false;
    this.cdr.detectChanges();
    this.showErrorMessage = true;
    this.cdr.detectChanges();
  }
  
  private pageChanged(event, num) {
    let sortParam = {};
    this.assessmentListdata["collections"] = this.assessmentListdataCopy;
    this.pageNumber = event.pageIndex;
    this.displayInputText(this.searchText, false);
    sortParam = { property: this.column, direction: this.direction };
    this.assessmentListdata["collections"] = this.collectionListPipe.transform(
      this.assessmentListdata["collections"],
      sortParam
    );
    const paginateParam = {
      itemsPerPage: this.itemsPerPage,
      currentPage: this.pageNumber,
    };
    this.assessmentListdata["collections"] = this.paginate.transform(
      this.assessmentListdata["collections"],
      paginateParam
    );
  }
  public displayInputText(event, doPaginate: boolean = true, isSearchByUser: boolean = false) {
    this.searchText = event;
    // Mark search as dirty only when user interacts with it
    if (isSearchByUser) {
      this.isSearchDirty = true;
    }
    this.assessmentListdata["collections"] = this.assessmentListdataCopy;
    let filteredAssessmentList = this.assessmentListdataCopy;
    this.collectionLength = this.assessmentListdata["collections"].length;
    let clearSearch = false;
    if (this.searchText !== "" && this.searchText.length > 2) {
      const searchParam = { collection_title: this.searchText };
      filteredAssessmentList = this.searchFilter.transform(
        this.assessmentListdata["collections"],
        searchParam,
        false
      );
    } else {
      clearSearch = true;
    }
    this.collectionLength = filteredAssessmentList.length;
    if ((clearSearch && doPaginate) || this.collectionLength <= 10) {
      this.pageNumber = 0;
    }
    if (doPaginate) {
      const paginateParam = {
        itemsPerPage: this.itemsPerPage,
        currentPage: this.pageNumber,
      };
      if (filteredAssessmentList != undefined) {
        filteredAssessmentList = this.paginate.transform(
          filteredAssessmentList,
          paginateParam
        );
      }
    }
    this.assessmentListdata["collections"] = filteredAssessmentList;
    this.updateResultsAnnouncement();
  }
  private updateResultsAnnouncement() {
    // Only announce results when search component is dirty (user has interacted with it)
    if (!this.isSearchDirty) {
      this.searchResultsAnnouncement = "";
      return;
    }

    const searchText = this.searchText?.trim() || "";
    const resultCount = this.collectionLength;
    const resultLabel = `${resultCount} result${resultCount !== 1 ? 's' : ''}`;

    this.searchResultsAnnouncement = searchText
      ? `${resultLabel} found for '${searchText}'`
      : `${resultLabel} found`;
    this.cdr.detectChanges();
  }
  private populateTestList(updateFocus: boolean = false) {
    this.assessmentListSubscription = this.assessmentList
      .getListCollection(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .subscribe(
        (data) => {
          this.assessmentListdata = data;
          if (
            this.assessmentListdata &&
            this.assessmentListdata["collections"]
          ) {
            this.collectionLength =
              this.assessmentListdata["collections"].length;
            this.totalItems = this.assessmentListdata["collections"].length;
            this.assessmentListdataCopy =
              this.assessmentListdata["collections"];
            this.displayInputText(this.searchText);
            this.setDefault();
            if (updateFocus) {
              setTimeout(() => {
                const firstKebabButton = document.querySelector('.btn-icon');
                if (firstKebabButton) {
                  (firstKebabButton as HTMLElement).focus();
                }
              });
            }
          }
        },
        (error) => {
          this.error = error;
        }
      );
  }
  public changeSize(event) {
    const element = this.renderer.selectRootElement("#searchfilter");
    element.style = "width:200px;";
  }
  toggle() {
    this.show = !this.show;
  }
  setDefault() {
    for (let sortobj in this.sortAscDsc) {
      this.sortAscDsc[sortobj] = "dpg-icon-system-sort-white";
    }
  }
  sort(property) {
    this.setDefault();
    if (this.currentSortColumn === property) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = property;
      this.currentSortDirection = 'asc';
    }
    var ctrl = this;
    let sortParam = {};
    ctrl.isDesc = !this.isDesc; //change the direction
    // ctrl.column = property;
    ctrl.direction = this.isDesc ? 1 : -1;
    this.sortAscDsc[property] = this.isDesc
      ? "dpg-icon-system-sort-up-white"
      : "dpg-icon-system-sort-down-white";
    ctrl.column = property == "modified_format" ? "modified" : property;
    sortParam = { property: ctrl.column, direction: ctrl.direction };
    ctrl.assessmentListdata["collections"] = ctrl.collectionListPipe.transform(
      this.assessmentListdataCopy,
      sortParam
    );
    this.displayInputText(this.searchText);
    setTimeout(() => {
      this.setColumnHeaderSort(property);
    }, 0);
  }

  private readonly columnMapping: { [key: string]: string } = {
    'collection_title': 'Test Title',
    'modified': 'Date modified',
    'isbnTitle': 'Product Title',
    'isbnAuthor': 'Author', 
    'isbnEdition': 'Edition',
    'modified_format': 'Format'
  };

  private setColumnHeaderSort(property: string): void {
    this.columnHeaders.forEach((headerRef: ElementRef) => {
      const ch = headerRef.nativeElement as Element;
      if (ch.hasAttribute('aria-sort')) {
        this.renderer.removeAttribute(ch, 'aria-sort');
      }
      const button = ch.querySelector('button[data-column]') as HTMLElement;
      if (button && button.dataset['column'] === property) {
        const ariaSortValue = this.currentSortDirection === 'asc' ? 'ascending' : 'descending';
        this.renderer.setAttribute(ch, 'aria-sort', ariaSortValue);
      }
    });
  }

  public refreshList() {
    let dateInSecs = Math.trunc(Date.now() / 1000);
    const localRenderer = this.renderer;
    const element = localRenderer.selectRootElement("#refreshSpinner");
    localRenderer.addClass(element, "fa-spin");

    // Reset search dirty flag if no search text to avoid announcements on refresh
    if (!this.searchText || this.searchText.trim() === '') {
      this.isSearchDirty = false;
    }

    setTimeout(() => {
      localRenderer.removeClass(element, "fa-spin");
      this.showSuccessAlert("List refreshed");
    }, 10000);
    if (this.lastRefreshTime == 0 || dateInSecs - this.lastRefreshTime > 15) {
      this.populateTestList();
      this.lastRefreshTime = dateInSecs;
    }
  }

  public resync(collectionId: string, collectionTitle: string) {
    this.resyncSubscription = this.assessmentList
      .resync(collectionId, collectionTitle)
      .subscribe(
        (data) => {
          this.showSuccessMessage = true;
          this.showSuccessAlert("Regeneration initiated for " + collectionTitle);
          this.populateTestList(true);
        },
        (err) => {
          if (
            err.hasOwnProperty("error") &&
            err.error.hasOwnProperty("Message")
          ) {
            this.errorMessage = err.error.Message;
          }
          this.showErrorMessage = true;
        }
      );
  }

  public downloadFile(
    collectionId: string,
    exportType: string,
    fileName: string
  ) {
    this.fileDownlodSubscription = this.assessmentList
      .downloadFile(collectionId, exportType)
      .subscribe(
        (data) => {
          var blob = new Blob([data], { type: "application/octet-stream" });
          var downloadURL = window.URL.createObjectURL(blob);
          var link = document.createElement("a");
          link.href = downloadURL;
          link.setAttribute("target", "_blank");
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          const self = this;
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadURL);
          }, 100);
        },
        (err) => {
          this.showExportErrorMessage = true;
        }
      );
  }
  createTest(testVal: MheOption[]) {
    if (testVal[0].value === 0) {
      this.router.navigate(["/editAssessment", "create"]);
    } else {
      this.showModal();
    }
  }
  handleKeyPress(event: KeyboardEvent, column: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.sort(column);
    }
  }

  onKebabModalStateChange(isOpen: boolean) {
    this.isAnyModalOpen = isOpen;
  }
}
